import { useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import "./addnewbankmodal.css";
import {
  IAvailableForCreditCardSaveShift,
  ICompanyBank,
} from "./shiftcreditcard/interface";
function AddNewBankModal(props: any) {
  const ref: any = useRef();
  const [isModalOpen, setIsModalOpen] = useState(props.show);
  const [currentBank, setCurrentBank] = useState<ICompanyBank>();
  const [banks, setBanks] = useState<ICompanyBank[]>([]);
  const [currentOptionValue, setCurrentOptionValue] = useState("");
  const [IsSelectInvalid, setIsSelectInvalid] = useState(true);
  const [languageData, setLanguageData] = useState<any>();
  // console.log(props);
  useEffect(() => {
    setIsModalOpen(props.show);
  }, [props.show]);

  useEffect(() => {
    const propBanks: ICompanyBank[] = [...props.companyBanks];
    const uniqueBanks: ICompanyBank[] = [];
    for (let i = 0; i < propBanks.length; i++) {
      let add = true;
      for (let j = 0; j < uniqueBanks.length; j++) {
        if (propBanks[i].bankId === uniqueBanks[j].bankId) {
          add = false;
          break;
        }
      }
      if (add) {
        uniqueBanks.push({ ...propBanks[i] });
      }
    }
    setBanks(uniqueBanks);
  }, [props.companyBanks]);

  useEffect(() => {
    setLanguageData(props.language);
  }, [props.language]);

  useEffect(() => {}, [currentBank]);

  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (isModalOpen && ref.current && !ref.current.contains(e.target)) {
        setIsModalOpen(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isModalOpen]);

  const handleOptionChange = (e: any) => {
    if (e.target.value === languageData?.data?.shiftCreditCard?.modal?.bank?.placeholder) {
      setIsSelectInvalid(false);
      setCurrentOptionValue(e.target.value);
    } else {
      setIsSelectInvalid(true);
      setCurrentOptionValue(e.target.value);
    }
  };

  const handleOnTrue = () => {
    if (currentOptionValue === languageData?.data?.shiftCreditCard?.modal?.bank?.placeholder || currentOptionValue === "") {
      setIsSelectInvalid(false);
    }

    const theBank: ICompanyBank[] = banks.filter((bank: ICompanyBank) => {
      if (bank.bankName === currentOptionValue) {
        return true;
      }
      return false;
    });
    let updatedBank;
    if (theBank.length === 1 && IsSelectInvalid) {
      updatedBank = {
        ...theBank[0],
        domId: props.companyBanks.length,
        amount: 0,
        batchNo: "",
        removable: true,
      };
      props.onTrue(updatedBank);
    }
  };

  return (
    <div>
      {isModalOpen ? (
        <div className={"modalU"}>
          <section className="modalU-main" ref={ref}>
            {props.totalCash ? (
              <h3 className={"custom-h"}>
                {languageData?.data?.general?.modal?.totalCash} {props.totalCash}
                &#8378;
              </h3>
            ) : (
              ""
            )}
            <h3 className={"custom-h"}>{props.question}</h3>
            <select
              className={IsSelectInvalid ? "" : "red-border"}
              value={currentOptionValue}
              onChange={handleOptionChange}
            >
              <option value={languageData?.data?.shiftCreditCard?.modal?.bank?.placeholder}>
                {languageData?.data?.shiftCreditCard?.modal?.bank?.placeholder}
              </option>
              {banks.map((bank: ICompanyBank, index: number) => {
                return (
                  <option key={index} value={bank.bankName}>
                    {bank.bankName}
                  </option>
                );
              })}
            </select>
            {!IsSelectInvalid ? (
              <p>{languageData?.data?.shiftCreditCard?.modal?.bank?.error || "Choose valid bank."}</p>
            ) : (
              ""
            )}
            <div className={"modalU-buttons"}>
              <button
                className={"custom-btn custom-btn-green"}
                type="button"
                onClick={handleOnTrue}
                disabled={!IsSelectInvalid}
              >
                {props.buttonText}
              </button>
              <button
                className={"custom-btn custom-btn-red "}
                type="button"
                onClick={props.handleClose}
              >
                {languageData?.data?.general?.modal?.cancel || "Cancel"}
              </button>
            </div>
          </section>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

function mapStateToProps(state: any) {
  // console.log(state);
  const { isLoggedIn } = state.authReducer ?? {};
  const { message } = state.messageReducer ?? {};
  const { user } = state.user ?? {};
  const { ...language } = state.languageReducer ?? {};
  return {
    isLoggedIn,
    message,
    user,
    language,
  };
}

export default connect(mapStateToProps)(AddNewBankModal);
